import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Draggable } from 'react-beautiful-dnd'

import InputSelectForm from '../forms/input-select-form'

class TableInputItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showInputSelectForm: false
    }
  }

  renderInputItem() {
    const { view, item } = this.props
    const { showInputSelectForm } = this.state

    const nonInstrument = (item.class === 'non-instrument')

    return (
      <Draggable draggableId={item.id} isDragDisabled={!view.editable || !nonInstrument} type="input-item">
        {(provided, snapshot) => (
          <div className="table-input-item">
            <div className="table-input-item--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle} >
              {
                nonInstrument && showInputSelectForm !== true
                ? <div className="table-input-item-handle" {...provided.dragHandleProps} />
                : null
              }

              {
                nonInstrument
                ? showInputSelectForm !== true
                  ? <div className="title link link--invert" data-value={item.title} onClick={() => this.setState({showInputSelectForm: !showInputSelectForm})}>
                      {item.title}
                    </div>
                  : <InputSelectForm
                      removeFocus={() => this.setState({showInputSelectForm: false})}
                      item={item}
                      itemIsSelected={(selectedItem) => this.props.editRiderItem({...selectedItem, id: item.id})}
                      deleteRiderItem={this.props.deleteRiderItem} />
                : <div className="title" data-value={item.title}>{item.title}</div>
              }
            </div>

            {provided.placeholder}
          </div>
        )}
      </Draggable>
    )
  }

  renderEmptyInputItem() {
    const { item } = this.props

    if (item.class !== 'non-instrument') return null

    return (
      <InputSelectForm
        removeFocus={() => this.props.removeRiderItem(item)}
        item={undefined}
        itemIsSelected={(selectedItem) => this.props.createRiderItem(selectedItem)} />
    )
  }

  render() {
    const { item } = this.props

    return item.id
    ? this.renderInputItem()
    : this.renderEmptyInputItem()
  }
}

TableInputItem.propTypes = {
  view: PropTypes.object,
  item: PropTypes.object,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func
}

TableInputItem.defaultProps = {
  view: {},
  item: {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  deleteRiderItem: function() {}
}

export default TableInputItem



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/output-table/table-input-item.js